export default "__VITE_ASSET__v4ifK7X9__"